export const data = [
  { name: "Direct", value: 400 },
  { name: "Paid", value: 300 },
  { name: "Social", value: 300 },
  { name: "Other", value: 200 }
];

export const COLORS = ["#37655F", "#647490", "#AAC9FF", "#30C6B5"];
